import { MaterialReactTable } from "material-react-table";
import { PaymentHistorycoloumn } from "./constants/PaymentHistorycoloumn";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getPaymentHistory } from "../../slices/payment/PaymentHistory/thunk";
import { customerIdData } from "./constants/constantFunctionsView";

export default function PaymentHistoryTable() {
    const dispatch = useDispatch();
    const customerId = customerIdData();

    const paymenthistoryData =
        useSelector((state) => state.getPaymentHistory.getPaymentHistory) || [];

    const [loading, setLoading] = useState(false);
    const [hasNextPage, setHasNextPage] = useState(true);

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    // store cursor per page
    const [cursorMap, setCursorMap] = useState({ 0: "" });

    // 🔹 Fetch data when page changes
    useEffect(() => {
        const cursor = cursorMap[pagination.pageIndex] ?? "";

        setLoading(true);

        dispatch(
            getPaymentHistory(customerId, setLoading, cursor, setHasNextPage)
        );
    }, [customerId, pagination.pageIndex]);

    // 🔹 Save next page cursor
    useEffect(() => {
        if (paymenthistoryData.length > 0) {
            const lastItem =
                paymenthistoryData[paymenthistoryData.length - 1];

            setCursorMap((prev) => ({
                ...prev,
                [pagination.pageIndex + 1]:
                    lastItem?.paymentCompletedAt || "",
            }));

            setHasNextPage(
                paymenthistoryData.length === pagination.pageSize
            );
        } else {
            setHasNextPage(false);
        }
    }, [paymenthistoryData]);

    // 🔹 Manual control of next/previous
    const handlePaginationChange = (updater) => {
        const newPagination =
            typeof updater === "function" ? updater(pagination) : updater;

        // block only if no next page
        if (
            newPagination.pageIndex > pagination.pageIndex &&
            !hasNextPage
        ) {
            return;
        }

        setPagination(newPagination);
    };

    const PaymentHistorycolumn = PaymentHistorycoloumn();

    return (
        <div className="border rounded-1 px-0  my-3  h-100">
            <MaterialReactTable
                columns={PaymentHistorycolumn}
                data={paymenthistoryData}
                manualPagination
                onPaginationChange={handlePaginationChange}
                rowCount={
                    pagination.pageIndex * pagination.pageSize +
                    paymenthistoryData.length +
                    (hasNextPage ? 1 : 0)
                }
                state={{ isLoading: loading, pagination }}
                enableBottomToolbar
                enableColumnActions
                enableRowActions={false}
                enableDensityToggle={false}
                enablePagination
                renderTopToolbar={false}
            />
        </div>
    );
}